import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import { getAllMembers } from "app/services/distributorService";

const MemberAutoComplete = ({
  setFieldValue,
  handleChangeOptions,
  refreshFilter,
  modelState,
}) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputValue, setInputValue] = useState("");

  // Initialize selected value if modelState.memId exists
  useEffect(() => {
    if (modelState?.memId && modelState?.member) {
      setSelectedValue({
        id: modelState.memId,
        label: `${modelState.member.uniqueIdentity} - ${modelState.member.company} - ${modelState.member.memberType}`,
        balance: modelState.member.balance || "0",
      });
    }
  }, [modelState]);

  // Handle input change event
  const handleInputChange = (value) => {
    setInputValue(value);
  };

  const handleChange = (value) => {
    setSelectedValue(value);
    handleChangeOptions(value);
  };

  // Load options using API call
  const loadOptions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const { data } = await getAllMembers(inputValue);
    const memberData = [];

    if (data?.data?.length > 0) {
      data.data.forEach((item) =>
        memberData.push({
          id: item.memId,
          label: `${item.uniqueIdentity} - ${item.company} - ${item.memberMobileNo} - ${item.memberType}`,
          balance: `${item.balance}`,
        })
      );
    }
    return memberData;
  };

  return (
    <AsyncSelect
      defaultOptions
      value={selectedValue} // Keep it selected
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={handleChange}
      name="memId"
      placeholder="Search Member"
    />
  );
};

export default MemberAutoComplete;
